import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Megaphone, Tag } from 'lucide-react';

const ROTULOS_TIPO = {
  preco_errado: 'Preço errado',
  etiqueta: 'Etiqueta diferente do sistema',
  sem_codigo_barras: 'Sem código de barras / não lê',
  outro: 'Outro',
};

export default function NotificacaoAvisoPwa({ notificacao, onClose }) {
  const [tempoRestante, setTempoRestante] = useState(60);
  const d = notificacao.dados;

  useEffect(() => {
    const t = setInterval(() => {
      setTempoRestante(prev => {
        if (prev <= 1) { clearInterval(t); onClose(); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [onClose]);

  return (
    <div className="w-96 bg-white rounded-xl shadow-2xl border-2 border-blue-400 overflow-hidden animate-slide-in">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <Megaphone className="w-6 h-6 text-blue-600" />
          </div>
          <div className="text-white">
            <h3 className="font-bold text-base leading-tight">Aviso de vendedor</h3>
            <p className="text-xs opacity-80">PWA Consulta de Preços</p>
          </div>
        </div>
        <button onClick={onClose} className="text-white hover:bg-white/20 rounded-lg p-1.5 transition-colors">
          <X className="w-5 h-5" />
        </button>
      </div>

      <div className="p-4 space-y-3">
        <div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
          <div className="flex items-center gap-2 text-blue-700 text-xs mb-1">
            <Tag className="w-3.5 h-3.5" />
            Cód. {d.codigo_produto}
          </div>
          <p className="font-bold text-gray-900">{d.nome_produto}</p>
          <p className="text-sm text-blue-800 font-medium mt-1">{ROTULOS_TIPO[d.tipo_aviso] || d.tipo_aviso}</p>
          {d.observacao && <p className="text-sm text-gray-700 mt-1">“{d.observacao}”</p>}
          {d.funcionario && <p className="text-xs text-gray-500 mt-1">Enviado por: {d.funcionario}</p>}
        </div>

        <Link to="/pwa/consultas" onClick={onClose} className="block text-center text-sm font-medium text-blue-700 hover:underline">
          Ver avisos abertos
        </Link>

        <div className="w-full bg-gray-100 rounded-full h-1.5">
          <div
            className="bg-blue-400 h-1.5 rounded-full transition-all duration-1000 ease-linear"
            style={{ width: `${(tempoRestante / 60) * 100}%` }}
          />
        </div>
        <p className="text-xs text-gray-400 text-center">Fechará em {tempoRestante}s</p>
      </div>
    </div>
  );
}

export { ROTULOS_TIPO };
